export default __webpack_public_path__ + "static/media/subLogo.6376e2e2.svg";